import { HttpMethods } from '@/config/urls'
import { ErrorHttpRequest } from '@/utils/errors'

export type Response<T> = T & {
  envelope?: any
  pagination?: {
    current: number
    pageSize: number
    total: number
  }
}

export async function fetcher<T>(
  plainTextUrl: string,
  init?: RequestInit
): Promise<Response<T>> {
  const url = new URL(`http://localhost${plainTextUrl}`)
  const response = await fetch(plainTextUrl, init)

  if (!response.ok) {
    const status = response.status
    const text = await response.text()
    throw new ErrorHttpRequest('Fetcher error', text, status)
  }

  const body = await response.json()
  // TODO: This is the legacy pagination mechanism, it is being replaced it must be removed soon!
  const paginationTotalCount = response.headers.get('x-total-count')
  if (paginationTotalCount && plainTextUrl.indexOf('?') > -1) {
    body.pagination = {
      current: Number.parseInt(url.searchParams.get('page')) + 1,
      pageSize: Number.parseInt(url.searchParams.get('size')),
      total: Number.parseInt(paginationTotalCount),
    }
  }
  return body as T
}

const buildFetcher =
  (init?: RequestInit) =>
  <T>(url: string, requestParameters?: any, controllerRef?: any) =>
  (): Promise<T> => {
    let requestInit = init

    if (controllerRef) {
      const controller = new AbortController()
      if (controllerRef.current) {
        controllerRef.current.abort()
      }
      controllerRef.current = controller
      requestInit = Object.assign({}, { signal: controller.signal }, init)
    }

    return fetcher<T>(url, requestInit).then((response) => {
      response.envelope = requestParameters
      return response as T
    })
  }

export const get = buildFetcher({ method: HttpMethods.GET })
export const patch = (init: RequestInit) =>
  buildFetcher({ method: HttpMethods.PATCH, ...init })
